
const Logo = ({className}:any) => (
    <img src='http://media.culturetravel.in/logo/ct-1200x637.png'
        alt="logo"
        className={`w-full ${className}`}
    />
);

export default Logo;
